module.exports = __webpack_public_path__ + "static/media/commute-video-002.0d1e914f.mp4";